import script from "./CpitnTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./CpitnTable.vue?vue&type=script&lang=ts&setup=true"

import "./CpitnTable.vue?vue&type=style&index=0&id=07f090ac&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07f090ac"]])

export default __exports__